import { useSelector } from 'react-redux';
import { useCallback } from 'react';

import { selectServicePageInfo } from '../../../selectors/servicePageInfo';
import { createCianAnalyticsPageViewObject } from '../../../utils/createCianAnalyticsPageViewObject';
import { trackEvent } from '../../../utils/tracking';

export interface IUseFileUploadTrackingResult {
  trackSelectDocuments: () => void;
}

export const useFileUploadTracking = (): IUseFileUploadTrackingResult => {
  const servicePageInfo = useSelector(selectServicePageInfo);

  const trackSelectDocuments = useCallback<() => void>(() => {
    trackEvent({
      action: 'Click',
      label: 'select_document',
      ...createCianAnalyticsPageViewObject(servicePageInfo),
    });
  }, [servicePageInfo]);

  return {
    trackSelectDocuments,
  };
};
